"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utcMinutes = exports.utcMinute = exports.timeMinutes = exports.timeMinute = void 0;
var _interval = require("./interval.js");
var _duration = require("./duration.js");
const timeMinute = (0, _interval.timeInterval)(date => {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond);
}, (date, step) => {
  date.setTime(+date + step * _duration.durationMinute);
}, (start, end) => {
  return (end - start) / _duration.durationMinute;
}, date => {
  return date.getMinutes();
});
exports.timeMinute = timeMinute;
const timeMinutes = timeMinute.range;
exports.timeMinutes = timeMinutes;
const utcMinute = (0, _interval.timeInterval)(date => {
  date.setUTCSeconds(0, 0);
}, (date, step) => {
  date.setTime(+date + step * _duration.durationMinute);
}, (start, end) => {
  return (end - start) / _duration.durationMinute;
}, date => {
  return date.getUTCMinutes();
});
exports.utcMinute = utcMinute;
const utcMinutes = utcMinute.range;
exports.utcMinutes = utcMinutes;